import React, { useState, useEffect } from "react";
import _ from "lodash";
import Photos from "./Photos";
import { withCartIdParam } from "../../../../utils/BrowserHelper";
import { LightBoxViewCartIcon } from "../vectors/AddToCartIcon";
import DownloadIcon from "../vectors/DownloadIcon";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";

interface FilteredResultProps {
  album: any;
  event: any;
  cart: any;
  addPhotoToCart: (photo: any) => void;
  removePhotoFromCart: Function;
  loadingAlbums: boolean;
  listOfMediaId: { id: number; hidden: boolean }[];
  curationMode: boolean;
  userId: number;
  userSignedIn: boolean;
  guestUserId: number | null;
  filteredPhotos: any;
  eventCoverPickerMode: boolean;
  isEmbed: boolean;
  cartId: number;
  loadPhotos: Function;
  filterSelections: object;
  reset: boolean;
  addAllToCart: (
    filters: any,
    photos: any[],
    callback: (isLoading: boolean) => void
  ) => void;
  activeFilters: () => any;
  pageConfiguration: { primaryColor: string; secondaryColor: string };
  securedGalleryView: boolean;
  handleDownload: (selectedPhotos: { id: number; hidden: boolean }[]) => void;
  downloadProcessing: boolean;
  setCollectDownloadEmailModal: (isOpen: boolean) => void;
  directDownloadEnabled: boolean;
  endUserDownloadsDisabled: boolean;
  updateCartFromApiResponse?: (apiResponse: any) => void;
  setSelfieUploadPopup?: (value: boolean) => void;
}

const FilteredResult: React.FC<FilteredResultProps> = ({
  album,
  event,
  cart,
  addPhotoToCart,
  removePhotoFromCart,
  loadingAlbums,
  listOfMediaId,
  curationMode,
  userId,
  userSignedIn,
  guestUserId,
  filteredPhotos,
  eventCoverPickerMode,
  isEmbed,
  cartId,
  loadPhotos,
  filterSelections,
  reset,
  addAllToCart,
  activeFilters,
  pageConfiguration,
  securedGalleryView,
  handleDownload,
  downloadProcessing,
  setCollectDownloadEmailModal,
  directDownloadEnabled,
  endUserDownloadsDisabled,
  updateCartFromApiResponse,
  setSelfieUploadPopup
}: FilteredResultProps) => {
  const [photos, setPhotos] = useState(filteredPhotos);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateFavorites = (photoId: number) => {
    const updatedPhotos = photos.filter(
      (photo: any) => photo.id != photoId && photo
    );
    setPhotos(updatedPhotos);
  };

  useEffect(() => {
    if (reset) {
      loadPhotos(filterSelections, true);
    }
  }, [reset]);

  const photosCount = () => {
    if (cart) {
      if (event.hasPrintProducts) {
        if (cart.sales_count !== undefined && cart.sales_count !== null) {
          return cart.sales_count;
        }
      }

      if (cart.photos) {
        return cart.photos.length;
      }
    }
    return 0;
  };

  const selectedPhotosCount = () => listOfMediaId.length;

  const freeEvent = () => event && event.price == 0;
  const anyUserId = userId || guestUserId;
  const isAuthorizedGallery = anyUserId || securedGalleryView;

  if (photos.length == 0) {
    return (
      <div className="dv-results">
        <div className="dv-event-no-albums">
          There are no photos matching your filters. Clear filters and try
          again.
        </div>
      </div>
    );
  } else {
    return (
      <div className="">
        <div
          className={
            "dv-filtered-result dv-album-details" +
            (eventCoverPickerMode ? " sticky-cover" : "")
          }
          translate="no"
        >
          <span>
            <h3>Filtered Photos</h3>
          </span>
          <div className="checkout ns filtered-photos-action-btns">
            {endUserDownloadsDisabled ? null : directDownloadEnabled ? (
              <div className="checkout ns">
                <button
                  className={
                    "btn  " +
                    (selectedPhotosCount() > 0
                      ? " secondary-btn"
                      : "disable-btn")
                  }
                  aria-label={`Download ${selectedPhotosCount()} selected photos`}
                  disabled={downloadProcessing || selectedPhotosCount() === 0}
                  style={{
                    pointerEvents:
                      selectedPhotosCount() > 0 ? "initial" : "none",
                    display: "flex",
                    alignItems: "center"
                  }}
                  onClick={() =>
                    isAuthorizedGallery
                      ? handleDownload(listOfMediaId)
                      : setCollectDownloadEmailModal(true)
                  }
                >
                  <DownloadIcon
                    color={ContrastForegroundUtility.fgColor(
                      pageConfiguration.secondaryColor
                    )}
                    style={{ width: "16px", height: "12px" }}
                  />

                  <span
                    className="photos"
                    style={{
                      color: `${ContrastForegroundUtility.fgColor(
                        pageConfiguration.secondaryColor
                      )}`
                    }}
                  >
                    &nbsp;{selectedPhotosCount()}{" "}
                    <span className="cta-label-divider">|</span> Download Now
                  </span>
                </button>
              </div>
            ) : (
              !curationMode && (
                <button
                  className="geo-btn geo-btn--secondary-ghost geo-btn--small geo-add-all-to-cart-btn"
                  onClick={() => {
                    setIsLoading(true);
                    addAllToCart(
                      activeFilters(),
                      photos,
                      (isLoading: boolean) => setIsLoading(isLoading)
                    );
                  }}
                  style={{ marginRight: 10 }}
                  disabled={isLoading}
                >
                  {" "}
                  Add all to cart
                  {isLoading ? (
                    <span
                      className="fa fa-spin fa-spinner"
                      style={{ marginLeft: "10px" }}
                    />
                  ) : null}
                </button>
              )
            )}
            {!eventCoverPickerMode && (
              <a
                href={withCartIdParam(
                  "/checkout?source=event-gallery",
                  cartId,
                  isEmbed
                )}
                target={isEmbed ? "_blank" : ""}
                className={
                  "btn  " +
                  (photosCount() > 0 ? " secondary-btn" : "disable-btn")
                }
                style={{
                  pointerEvents: photosCount() > 0 ? "initial" : "none"
                }}
              >
                <LightBoxViewCartIcon
                  color={ContrastForegroundUtility.fgColor(
                    pageConfiguration.primaryColor
                  )}
                />
                <span
                  className="photos"
                  style={{
                    color: `${ContrastForegroundUtility.fgColor(
                      pageConfiguration.primaryColor
                    )}`
                  }}
                >
                  &nbsp;{photosCount()}
                </span>
              </a>
            )}
          </div>
        </div>
        <div>
          <Photos
            event={event}
            album={album[0]}
            photos={photos}
            cart={cart}
            addPhotoToCart={addPhotoToCart}
            removePhotoFromCart={removePhotoFromCart}
            loadingPhotos={loadingAlbums}
            loadMorePhotos={() => {}}
            updateAlbum={updateFavorites}
            collapsibleGallery={true}
            expanded={true}
            galleryRowsRendered={() => {}}
            listOfMediaId={listOfMediaId}
            curationMode={curationMode}
            userId={userId}
            userSignedIn={userSignedIn}
            guestUserId={guestUserId}
            filteredResult={true}
            updateCartFromApiResponse={updateCartFromApiResponse}
            setSelfieUploadPopup={setSelfieUploadPopup}
          />
        </div>
      </div>
    );
  }
};

export default FilteredResult;
